import React, { useState, useEffect } from 'react';
import { Box, Paper, TextField, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination } from '@mui/material';
import axios from 'axios';

const StockMercDetails = () => {
  const [data, setData] = useState([]);
  const [filterReferencia, setFilterReferencia] = useState('');
  const [filterNome, setFilterNome] = useState('');
  const [filterTipo, setFilterTipo] = useState('');
  const [filterCertificado, setFilterCertificado] = useState('');
  const [filterFornecedores, setFilterFornecedores] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const apiBaseURL = 'https://plasticemployers.duckdns.org';

  // Buscar os artigos existentes via API (GET)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiBaseURL}/api/artigos-mercadoria/`);
        // Supondo que a resposta seja um array com os artigos
        setData(response.data);
      } catch (error) {
        console.error('Erro ao buscar detalhes de estoque:', error);
      }
    };
    fetchData();
  }, []);

  // Filtrar os dados conforme os campos de filtro
  const filteredData = data.filter(item =>
    item.referencia.toLowerCase().includes(filterReferencia.toLowerCase()) &&
    item.nome.toLowerCase().includes(filterNome.toLowerCase()) &&
    item.tipo.toLowerCase().includes(filterTipo.toLowerCase()) &&
    (filterCertificado === '' || (item.certificado && item.certificado.toLowerCase().includes(filterCertificado.toLowerCase()))) &&
    (filterFornecedores === '' || (item.fornecedores && item.fornecedores.join(', ').toLowerCase().includes(filterFornecedores.toLowerCase())))
  );

  const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  // Se filtro por tipo estiver ativo, calcular o máximo de stock_maximo entre os itens filtrados
  let maxStockMaximo = 0;
  if (filterTipo.trim() !== '' && filteredData.length > 0) {
    maxStockMaximo = Math.max(...filteredData.map(item => item.stock_maximo || 0));
  }

  return (
    <Paper sx={{ p: 3, mt: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Detalhes de Estoque</Typography>
      {/* Filtros */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
        <TextField
          label="Referencia"
          value={filterReferencia}
          onChange={(e) => { setFilterReferencia(e.target.value); setPage(0); }}
        />
        <TextField
          label="Nome"
          value={filterNome}
          onChange={(e) => { setFilterNome(e.target.value); setPage(0); }}
        />
        <TextField
          label="Tipo"
          value={filterTipo}
          onChange={(e) => { setFilterTipo(e.target.value); setPage(0); }}
        />
        <TextField
          label="Certificado"
          value={filterCertificado}
          onChange={(e) => { setFilterCertificado(e.target.value); setPage(0); }}
        />
        <TextField
          label="Fornecedores"
          value={filterFornecedores}
          onChange={(e) => { setFilterFornecedores(e.target.value); setPage(0); }}
        />
      </Box>
      {/* Se houver filtro por tipo, exibir o gráfico */}
      {filterTipo.trim() !== '' && filteredData.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>Gráfico de Stock Máximo</Typography>
          {filteredData.map(item => (
            <Box key={item.referencia} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Typography sx={{ width: '100px' }}>{item.referencia}</Typography>
              <Box
                sx={{
                  backgroundColor: 'primary.main',
                  height: '20px',
                  width: `${(item.stock_maximo / maxStockMaximo) * 100}%`,
                  transition: 'width 0.3s'
                }}
              />
              <Typography sx={{ ml: 1 }}>{item.stock_maximo}</Typography>
            </Box>
          ))}
        </Box>
      )}
      {/* Tabela */}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Referencia</TableCell>
              <TableCell>Nome</TableCell>
              <TableCell>Tipo</TableCell>
              <TableCell>Quantidade por Caixa</TableCell>
              <TableCell>Certificado</TableCell>
              <TableCell>Fornecedores</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.map(item => (
              <TableRow key={item.referencia}>
                <TableCell>{item.referencia}</TableCell>
                <TableCell>{item.nome}</TableCell>
                <TableCell>{item.tipo}</TableCell>
                <TableCell>{item.quantidade_por_caixa}</TableCell>
                <TableCell>{item.certificado}</TableCell>
                <TableCell>{Array.isArray(item.fornecedores) ? item.fornecedores.join(', ') : item.fornecedores}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={filteredData.length}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
      />
    </Paper>
  );
};

export default StockMercDetails;
